import {fadeOut, fadeIn} from './fade';

export default function () {
	const units = document.querySelectorAll('.js-tab-unit');
	let isProceeing = false;

	[].forEach.call(units, (unit)=> {
		const btns = unit.querySelectorAll('[role="tablist"] button');
		const panels = unit.querySelectorAll('[role="tabpanel"]');

		[].forEach.call(btns, (btn)=> {
			btn.onclick = (e) => {
				if(!isProceeing) {
					isProceeing = true;
					const el = e.currentTarget;
					const targetId = el.getAttribute('aria-controls');
					[].forEach.call(btns, (btn)=> {
						btn.setAttribute('aria-selected', 'false');
					});
					[].forEach.call(panels, (panel)=> {
						panel.style.display = 'none';
					});
					el.setAttribute('aria-selected', 'true');
					const target = document.getElementById(targetId);
					let count = target.getAttribute('data-count');
					count = Number(count) + 1;
					target.setAttribute('data-count', count);
					$('#'+targetId).fadeIn(function() {
						$(window).trigger('kidstabChanged', $('#'+targetId));
						isProceeing = false;
					});
				}
			};


		});
	});
}
